// Persistor genérico para sobrevivir el ciclo de auth.
// Cualquier ruta intentada sin sesión se guarda acá. Post-login, el RootGate
// la lee y navega al destino original en lugar de mandar a /.

const KEY = "fideliza:redirectAfterLogin";

function isSafePath(path: string): boolean {
  // Solo permitir paths internos (que arranquen con / pero no //).
  if (!path.startsWith("/")) return false;
  if (path.startsWith("//")) return false;
  // Bloquear paths reservados que ya manejan su propio gate.
  if (path === "/login" || path === "/signup") return false;
  return true;
}

export function rememberRedirect(pathWithQuery: string | null): void {
  if (!pathWithQuery || !isSafePath(pathWithQuery)) return;
  try {
    sessionStorage.setItem(KEY, pathWithQuery);
  } catch {
    /* ignore */
  }
}

export function readRedirect(): string | null {
  try {
    const v = sessionStorage.getItem(KEY);
    return v && isSafePath(v) ? v : null;
  } catch {
    return null;
  }
}

export function clearRedirect(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

// Llamar apenas carga la app, ANTES de que el router redirija a /login.
export function captureRedirectFromUrl(): void {
  try {
    const path = window.location.pathname + window.location.search;
    if (path === "/" || path === "/login") return; // home y login no son redirects útiles
    rememberRedirect(path);
  } catch {
    /* ignore */
  }
}
